import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KraIncentivesRoutingModule } from './kra-incentives-routing.module';
import { KraIncentiveListComponent } from './kra-incentive-list/kra-incentive-list.component';
import { KraIncentiveListAddComponent } from './kra-incentive-list-add/kra-incentive-list-add.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TimepickerModule } from 'ngx-bootstrap';
import { AppMaterialModule } from 'src/app/app-material.module';


@NgModule({
  declarations: [
    KraIncentiveListComponent,
    KraIncentiveListAddComponent
  ],
  imports: [
    CommonModule,
    KraIncentivesRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    DataTablesModule,
    BsDatepickerModule.forRoot(),
    NgbModule,
    NgMultiSelectDropDownModule,
    TimepickerModule.forRoot(),
    AppMaterialModule
  ]
})
export class KraIncentivesModule { }
